// src/pages/RequestAccess.js
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./RequestAccess.css";

const RequestAccess = () => {
  const [email, setEmail] = useState("");
  const [fullName, setFullName] = useState("");
  const [company, setCompany] = useState("");
  const [country, setCountry] = useState("");
  const [jobTitle, setJobTitle] = useState("");
  const [errors, setErrors] = useState({});
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Basic validation
    const newErrors = {};
    if (!email.includes("@")) newErrors.email = "Enter a valid email address.";
    if (!fullName.trim()) newErrors.fullName = "Full Name is required.";
    if (!company.trim()) newErrors.company = "Company Name is required.";
    if (!country.trim()) newErrors.country = "Country is required.";
    if (!jobTitle.trim()) newErrors.jobTitle = "Job Title is required.";

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    // Reset errors and start loading
    setErrors({});
    setLoading(true);
    setMessage("");

    // Create request payload
    const requestData = {
      fullName,
      email,
      company,
      country,
      jobTitle,
    };

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/auth/request-access`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(requestData),
      });

      const data = await response.json();

      if (response.ok) {
        setMessage("Your request has been submitted successfully! Check your email.");
        setFullName("");
        setEmail("");
        setCompany("");
        setCountry("");
        setJobTitle("");
      } else {
        setMessage(data.error || "Failed to submit request.");
      }
    } catch (err) {
      setMessage("Something went wrong. Please try again later.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* Sticky header with Back Button */}
      <div
        className="head"
        style={{
          position: "sticky",
          top: 0,
          zIndex: 1000,
          backgroundColor: "#000",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          padding: "10px 20px",
        }}
      >
        <button
          className="back-button"
          style={{
            backgroundColor: "transparent",
            border: "none",
            color: "#fff",
            cursor: "pointer",
          }}
          onClick={() => navigate("/")}
        >
          {/* <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#e3e3e3"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"/></svg> */}
          &#x227A; Back
          
        </button>
      </div>

      <div className='login-container'>
        <h1 className="logo-login middle-align" onClick={() =>navigate('/')}>
        <img src="/CommentInsight Favicon.png" alt="Logo" className="logo-image" />
          CommentInsight</h1>
      </div>

      {/* Form Section */}
      <div className="login-container wide-length">
        <h1>Ready to take the guesswork out of your content strategy?</h1>
        <p>
          You've experienced the power of our platform—now unlock full access to
          take your insights to the next level. Request access today and
          continue making data-driven decisions with confidence.
        </p>

        <form className="login-form" onSubmit={handleSubmit}>
          {/* Company Name */}
          <input
            type="text"
            id="company"
            name="company"
            placeholder="Company Name*"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
          />
          {errors.company && <span className="error-message">{errors.company}</span>}

          {/* Country */}
          <input
            type="text"
            id="country"
            name="country"
            placeholder="Country*"
            value={country}
            onChange={(e) => setCountry(e.target.value)}
            required
          />
          {errors.country && <span className="error-message">{errors.country}</span>}

          {/* Job Title */}
          <input
            type="text"
            id="jobTitle"
            name="jobTitle"
            placeholder="Job Title*"
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            required
          />
          {errors.jobTitle && <span className="error-message">{errors.jobTitle}</span>}

          {/* Full Name */}
          <input
            type="text"
            id="fullName"
            name="fullName"
            placeholder="Full Name*"
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            required
          />
          {errors.fullName && <span className="error-message">{errors.fullName}</span>}

          {/* Email */}
          <input
            type="email"
            id="email"
            name="email"
            placeholder="Email address*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          {errors.email && <span className="error-message">{errors.email}</span>}

          {/* Submit Button */}
          <button className="signup-btn" type="submit" disabled={loading}>
          <svg xmlns="http://www.w3.org/2000/svg" height="22px" viewBox="0 0 24 24" width="35px" fill="#ffffff"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M3.4 20.4l17.45-7.48c.81-.35.81-1.49 0-1.84L3.4 3.6c-.66-.29-1.39.2-1.39.91L2 9.12c0 .5.37.93.87.99L17 12 2.87 13.88c-.5.07-.87.5-.87 1l.01 4.61c0 .71.73 1.2 1.39.91z"/></svg>
            {loading ? "Submitting..." : "Request Access"}
          </button>

          {/* Back Button */}
  

          {/* Success/Error Message */}
          {message && <p className="success-message">{message}</p>}
        </form>
      </div>
    </>
  );
};

export default RequestAccess;
